import React from 'react';
import Styles from './Contact.module.css'




function Contact() {
    return (
        <div className={Styles.main_page}>
            <h1>Contact Us</h1>
            <p >Any question or remarks? Just write us a massage!</p>
            <div id="contact-container" className={Styles.contact_container}>
                <div className={Styles.contact_info}>
                    <h4>Contact Information</h4>
                    <p>Fill up the form and our Team will back to you within 24 hours.</p>
                    <div>
                    <div className={Styles.icon_text}>
                        <ion-icon name="call-outline"></ion-icon>
                        <div className={Styles.phonnuber}>
                        <span> +995 32 2923594</span>
                        <span> +995 595 587000</span>
                        <span> +995 599 190391</span>
                        </div>
                    </div>
                    <div className={Styles.icon_text}>
                        <ion-icon name="mail-outline"></ion-icon>
                        <span>Reservations@avis.ge</span>
                    </div>
                    <div className={Styles.icon_text}>

                        <ion-icon name="location-outline" ></ion-icon>
                        <div className={Styles.misamarti}>
                        <span>Countyard by Marriott <br/> Tbilisi
                        4, Freedom Square, <br/>
                        0105 Tbilisi, Georgia</span>
                        </div>
                    </div>
                    <div className={Styles.social_media}>
                        <a className={Styles.icon_circle}>
                            <i className={Styles.icon}>

                            </i>

                        </a>

                    </div>
                    </div>

                </div>
                <form>
                    <div className={Styles.col}>
                        <div className={Styles.form_group}>
                            <label>First Name</label>
                            <input type='text' />
                        </div>
                        <div className={Styles.form_group}>
                            <label>Last Name</label>
                            <input type='text' />
                        </div>


                    </div>

                    <div className={Styles.col}>
                        <div className={Styles.form_group}>
                            <label>E-Mail</label>
                            <input type='email' />
                        </div>
                        <div className={Styles.form_group}>
                            <label>Phone</label>
                            <input type='tel' />
                        </div>
                    </div>

                    <div className={Styles.col}>
                        <div className={Styles.form_groupe}>

                            <label>Message</label>

                            <textarea></textarea>

                        </div>

                    </div>

                    <div className={Styles.col}>
                        <div className={Styles.form_groupee}>
                            <button className={Styles.primary}>Send Message</button>
                        </div>

                    </div>

                </form>

            </div>


        </div>
    )
}

export default Contact